import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DebitForm from './debit-form/debitForm';
import { KEY } from 'web/components/utils/stripeKey';
import styles from './debit.module.scss';

const stripePromise = loadStripe(KEY);

const DebitCard = ({ cardType, accountType, stepSelected, props, setFieldValue, id, pageLanguageContents, paymentFor }) => {
  return (
    <div className={styles.body}>
      <Elements stripe={stripePromise}>
        <DebitForm
          cardType={cardType}
          accountType={accountType}
          stepSelected={stepSelected}
          props={props}
          setFieldValue={setFieldValue}
          id={id}
          pageLanguageContents={pageLanguageContents}
          paymentFor={paymentFor} />
      </Elements>
    </div>
  );
};
export default DebitCard;
